import { cn } from '@linka/utils';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { container?: HTMLElement | null }
>(({ className, align = 'center', sideOffset = 4, container, ...props }, ref) => (
  // NOTE: `container` portaliza o popover fora da árvore do gatilho. Dentro de um
  // dialog, o Radix portaliza no container do próprio dialog e o wrapper
  // `[data-radix-popper-content-wrapper]` cria stacking context — qualquer irmão
  // posterior (uma linha de lista) pinta sobre o popover, e z-index no Content não
  // resolve porque a classe fica dentro do wrapper. Portalizar no `body` resolve.
  <PopoverPrimitive.Portal container={container}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-50 w-full rounded-md border border-ctx-layout-border bg-base-neutral-white p-nano text-ctx-content-base shadow-level1 outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent };
